import React from 'react'
import PageTitleWrapper, { IPageTitleData } from '../typography/PageTitleWrapper'

interface ILegalPageTitleProps {
  model: {
    seo: {
      title: string
    }
    mobileTitleOverride?: string
    desktopTitleOverride?: string
  }
}

const getPageTitleData = (title: string): IPageTitleData => ({
  pageTitleLine1: title,
  pageTitleLine2: '',
  mobilePageTitleLine1: title,
  mobilePageTitleLine2: '',
})

const LegalPageTitle = ({ model }: ILegalPageTitleProps) => {
  if (model.mobileTitleOverride || model.desktopTitleOverride) {
    return (
      <>
        <div className="hidden lg:block">
          <PageTitleWrapper 
            pageTitleData={getPageTitleData(model.desktopTitleOverride ?? model.seo.title)} 
            className="mb-12"
          />
        </div>
        <div className="lg:hidden">
          <PageTitleWrapper 
            pageTitleData={getPageTitleData(model.mobileTitleOverride ?? model.seo.title)} 
            className="mb-12"
          />
        </div>
      </>
    )
  }
  return (
    <PageTitleWrapper 
      pageTitleData={getPageTitleData(model.seo.title)} 
      className="mb-12"
    />
  )
}

export default LegalPageTitle
